import React from 'react';
import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { BRAND } from '../../theme/brandTokens';
import { formatCalendarDate } from '../../utils/dateFormatUtils';
import { formatCurrency } from '../../utils/currencyUtils';
import { formatStockQuantity } from '../../utils/stockQuantityUtils';

const ProductStockSummary = ({
  stockOnHand,
  contentQuantity,
  stockUnit,
  lastUnitCost,
  lastPurchaseDate,
  canSeeCosts = false,
  currency,
}) => {
  const { t } = useTranslation();
  const onHandLabel = formatStockQuantity({
    stockOnHand,
    contentQuantity,
    stockUnit,
  });

  return (
    <Box
      id="product-stock-summary"
      sx={{
        p: 2,
        borderRadius: 2,
        border: `1px solid ${BRAND.line}`,
        backgroundColor: BRAND.background,
        display: 'flex',
        flexDirection: 'column',
        gap: 0.75,
      }}
    >
      <Typography variant="subtitle2" sx={{ fontWeight: 700 }}>
        {t('productsManagement.fields.onHand')}
      </Typography>
      <Typography variant="h6" sx={{ fontWeight: 700, color: BRAND.primaryText }}>
        {onHandLabel}
      </Typography>
      <Typography variant="body2" color="text.secondary">
        {t('productsManagement.fields.stockIncreasesOnPurchase')}
      </Typography>
      {canSeeCosts ? (
        <Typography variant="body2" color="text.secondary">
          {lastUnitCost == null
            ? t('productsManagement.fields.noCostYet')
            : t('productsManagement.fields.lastCost', {
              cost: formatCurrency(lastUnitCost, currency),
              date: formatCalendarDate(lastPurchaseDate),
            })}
        </Typography>
      ) : null}
    </Box>
  );
};

export default ProductStockSummary;
